import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import useSiteSEO from '@/hooks/useSiteSEO';
import { META_PIXEL_ID, initMetaPixel, trackMetaPageView } from '@/utils/metaPixel.mjs';

export default function MetaPixel() {
  const location = useLocation();
  const { data: seo } = useSiteSEO();
  const trackedPath = useRef('');

  useEffect(() => {
    initMetaPixel(META_PIXEL_ID, window);
    const extra = String(seo?.facebook_pixel_id || '').trim();
    if (extra) initMetaPixel(extra, window);
    if (trackedPath.current === location.pathname) return;
    trackedPath.current = location.pathname;
    trackMetaPageView(window);
  }, [location.pathname, seo?.facebook_pixel_id]);

  return null;
}
